import axios, { AxiosError, AxiosResponse } from "axios";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { carrierUrls } from "../../URL/ApplicationUrls";
import { MdmApiError } from "../../Errors/MdmApiError";
import { deleteSuccessMessage } from "../../Messages/successMessages";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";

export const useDeleteCarrier = () => {
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (id: number | string | undefined) => {
      return axios.delete<number>(carrierUrls.carrierWithId(id).apiUrl);
    },
    onSuccess: async (response: AxiosResponse<number>) => {
      toast.success(deleteSuccessMessage(response.data, "Carrier"));
      navigate(carrierUrls.base.uiPath);
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
